import React, { useState } from 'react';
import { useElementDeleteContext } from '../contexts/ElementDeleteContext';
import './style/ContenuElements.css';
import { useUserContext } from '../contexts/UserContext'; // ou chemin relatif correct
import axios from 'axios';
import { useTranslation } from 'react-i18next'; // Import useTranslation

const baseUrl = process.env.REACT_APP_API_URL;
const endpointEvents = `${baseUrl}/download-imgcom`;

function ContenuElements({ items, type, tabSelector, setTabSelector }) {
  const { t } = useTranslation(); // Initialize the translation function
  const [selectedItems, setSelectedItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [selectionMode, setSelectionMode] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const { deleteElements } = useElementDeleteContext();
  const { tokens } = useUserContext();

  const handleSelectItem = (item) => {
    const alreadySelected = selectedItems.find(i => i.id === item.id);
    if (alreadySelected) {
      setSelectedItems(prev => prev.filter(i => i.id !== item.id));
    } else {
      setSelectedItems(prev => [...prev, { id: item.id, eventId: item.eventId, signedUrl: item.signedUrl, commentaire: item.commentaire }]);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteElements(selectedItems);
      setSuccessMessage(t('contenuElements.messages.deleteSuccess', { count: selectedItems.length }));
      setSelectedItems([]);
      setSelectionMode(false);
    } catch (err) {
      setErrorMessage(t('contenuElements.messages.deleteError'));
      console.error(err);
    } finally {
      setShowModal(false);
      setTimeout(() => {
        setSuccessMessage('');
        setErrorMessage('');
      }, 4000);
    }
  };

  const handleDownloadViaLambda = async () => {
    const token = tokens?.accessToken;
    const s3BaseUrl = process.env.REACT_APP_S3_UPLOAD_URL;
    if (!token) return;

    const payload = {
      items: selectedItems.map(i => {
        let key = null;
        try {
          if (i.signedUrl) {
            const url = new URL(i.signedUrl);
            key = url.pathname.startsWith('/') ? url.pathname.slice(1) : url.pathname;
          }
        } catch (e) {
          console.warn("❌ URL mal formée:", i.signedUrl);
        }

        return key ? { key, commentaire: i.commentaire || null } : null;
      }).filter(Boolean) // ⚠️ on retire les items null
    };


    try {
      const res = await axios.post(endpointEvents, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const urls = res.data.files;

      urls.forEach(file => {
        const a = document.createElement('a');
        a.href = file.url;
        a.download = file.key.split('/').pop();
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });

    } catch (err) {
      console.error("❌ Erreur téléchargement direct :", err);
    }
  };

  const sortByCreatedAt = (array) => {
    return array.slice().sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateA - dateB;
    });
  };

  const handleSelectAllImages = () => {
  const allImages = items
    .filter(item => item.signedUrl)
    .map(item => ({
      id: item.id,
      eventId: item.eventId,
      signedUrl: item.signedUrl,
      commentaire: item.commentaire
    }));

  setSelectedItems(allImages);
  };


  return (
    <div>
      <div className="delete-header">
        <div className="delete-tabs">
          <button
            onClick={() => setTabSelector('images')}
            className={tabSelector === 'images' ? 'active' : ''}
          >
            {t('contenuElements.tabs.images')}
          </button>
          <button
            onClick={() => setTabSelector('commentaires')}
            className={tabSelector === 'commentaires' ? 'active' : ''}
          >
            {t('contenuElements.tabs.comments')}
          </button>
        </div>

        {!selectionMode ? (
          <button onClick={() => setSelectionMode(true)} className="delete-button">
            {t('contenuElements.buttons.select')}
          </button>
        ) : (
          <div className="action-buttons">
            <button
              onClick={handleDownloadViaLambda}
              className={`download-button ${selectedItems.length === 0 ? 'disabled' : ''}`}
              disabled={selectedItems.length === 0}
            >
              {t('contenuElements.buttons.download', { count: selectedItems.length })}
            </button>
            <button
              onClick={handleSelectAllImages}
              className={`download-button `}
              
            >
              {t('contenuElements.buttons.selectAll')}
          </button>
          
            <button
              onClick={() => setShowModal(true)}
              className={`delete-button ${selectedItems.length === 0 ? 'disabled' : ''}`}
              disabled={selectedItems.length === 0}
            >
              {t('contenuElements.buttons.delete', { count: selectedItems.length })}
            </button>
          </div>
        )}
      </div>

      {successMessage && <p className="success-message">{successMessage}</p>}
      {errorMessage && <p className="error-message">{errorMessage}</p>}

      {tabSelector === 'images' && (
        <ul className="photo-gallery">
          {sortByCreatedAt(items.filter(item => item.signedUrl)).map((item, index) => (
            <li key={index} className="photo-item">
              {selectionMode && (
                <input
                  type="checkbox"
                  checked={!!selectedItems.find(i => i.id === item.id)}
                  onChange={() => handleSelectItem(item)}
                />
              )}
              <img
                src={item.thumbnailSignedUrl || item.signedUrl} // ✅ thumbnail si dispo, fallback sinon
                alt={t('contenuElements.preview.altTextImage', { index: index })}
                loading="lazy"
                onClick={() => !selectionMode && setPreviewImage(item.signedUrl)} // ✅ preview en grand = image HD
                className="thumbnail"
              />

            </li>
          ))}
        </ul>
      )}

      {tabSelector === 'commentaires' && (
        <ul className="delete-list">
          {sortByCreatedAt(items.filter(item => !item.signedUrl)).map((item, index) => (
            <li key={index} className="delete-item">
              {selectionMode && (
                <input
                  type="checkbox"
                  checked={!!selectedItems.find(i => i.id === item.id)}
                  onChange={() => handleSelectItem(item)}
                />
              )}
              <div className="delete-comment">
                <p>{item.commentaire}</p>
              </div>
            </li>
          ))}
        </ul>
      )}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-container">
            <h3>{t('contenuElements.modal.confirmationTitle')}</h3>
            <p>
              {tabSelector === 'images' ?
                t('contenuElements.modal.confirmationTextImages', { count: selectedItems.length }) :
                t('contenuElements.modal.confirmationTextComments', { count: selectedItems.length })
              }
            </p>
            <div className="modal-buttons">
              <button onClick={() => setShowModal(false)} className="cancel-button">
                {t('contenuElements.modal.cancelButton')}
              </button>
              <button onClick={handleConfirmDelete} className="confirm-button">
                {t('contenuElements.modal.confirmButton')}
              </button>
            </div>
          </div>
        </div>
      )}

      {previewImage && (
        <div className="preview-overlay" onClick={() => setPreviewImage(null)}>
          <img src={previewImage} alt={t('contenuElements.preview.altText')} className="preview-image" />
        </div>
      )}
    </div>
  );
}

export default ContenuElements;
